export type NotificationItem = {
  uuid: string
  created_at: string
  type: string
  title: string
  description: string
  producer: string
  recipient: string
  is_read: boolean
  payload: NotificationPayload
}

export type NotificationPayload = {
  extra: NotificationPayloadExtra | null
  action: NotificationActions
  object_id: string
  content_type: string
}

export type NotificationPayloadExtra = {
  shared?: boolean
  [key: string]: string | boolean | undefined
}

export type FirebaseMessageData = {
  badge_count: string
  created_at: string
  type: string
  title: string
  description: string
  payload: string
}

export type MarkAsReadData = {
  is_read: boolean
}

export type BadgeCountData = {
  badge_count: number
}

export type DeviceRegistrationData = {
  name?: string
  registration_id: string
  device_id?: string
  active?: boolean
  type: 'web'
}

export type MarkAsReadFunc = (id: string, data: MarkAsReadData) => Promise<void>

export type GetNotificationsParams = {
  limit?: number
  offset?: number
}

export enum NotificationActions {
  OPEN = 'open',
  READ = 'read'
}
